import {configureStore, type Action, type ThunkAction} from "@reduxjs/toolkit";
import dialogReducer from './dialog.slice.ts';
import preloaderReducer from './loader.slice.ts';
import onairReducer from './onair.slice.ts';
import modalReducer from './modal.slice.ts';
import modalBottomReducer from './modal.bottom.slice.ts';

export const store = configureStore({
  reducer: {
    dialog: dialogReducer,
    preloader: preloaderReducer,
    onair: onairReducer,
    modal: modalReducer,
    modalBottom: modalBottomReducer,
  },
});

// 타입들 정의
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action>;